module.exports = __webpack_public_path__ + "static/media/auric-oak-logo.8ffeb1d0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/main/assets/images/logos/auric-oak-logo.svg
// module id = 70
// module chunks = 0